/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListAutomationsQueryResponse,
  ListAutomationsQueryParams,
} from '../types/ListAutomations'

function getListAutomationsUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/automations/automations/` as const,
  }
  return res
}

/**
 * @description ViewSet for managing automations.
 * Provides CRUD operations for automations with different serializers
 * for list, detail, and create/update operations.
 * @summary List automations
 * {@link /api/v1/automations/automations/}
 */
export async function listAutomations(
  params?: ListAutomationsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListAutomationsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListAutomationsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
